import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../pagination.js';

import {
  SupplierPaymentTermsKindSchema,
  SupplierRoleStatusSchema,
} from './supplier-role.schemas.js';

export const SupplierRoleListPartySchema = z.object({
  name: z.string(),
  personType: z.enum(['INDIVIDUAL', 'COMPANY']),
  documentLabel: z.string().nullable(),
  phones: z.array(z.string()).default([]),
  emails: z.array(z.string()).default([]),
  commercialContacts: z
    .array(
      z.object({
        name: z.string(),
        commercialType: z.enum(['SALESPERSON', 'REPRESENTATIVE', 'OTHER']),
        commercialTypeLabel: z.string().nullable(),
        phones: z.array(z.string()),
        emails: z.array(z.string()),
      }),
    )
    .default([]),
});

export const SupplierRoleListItemSchema = z.object({
  supplierRoleId: z.uuid(),
  partyId: z.uuid(),
  status: SupplierRoleStatusSchema,
  paymentTermsKind: SupplierPaymentTermsKindSchema,
  paymentDays: z.number().int().positive().nullable(),
  internalCode: z.string().nullable(),
  party: SupplierRoleListPartySchema,
  createdAt: z.iso.datetime(),
});

export const SupplierRoleListSortFieldSchema = z.enum([
  'name',
  'document',
  'personType',
  'status',
  'payment',
  'internalCode',
]);
export type SupplierRoleListSortField = z.infer<typeof SupplierRoleListSortFieldSchema>;

export const ListSupplierRolesQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(1).max(100).optional(),
  ),
  partyId: z.uuid().optional(),
  sort: SupplierRoleListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export const ListSupplierRolesResponseSchema = z.object({
  items: z.array(SupplierRoleListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListSupplierRolesQuery = z.infer<typeof ListSupplierRolesQuerySchema>;
export type ListSupplierRolesResponse = z.infer<typeof ListSupplierRolesResponseSchema>;
export type SupplierRoleListItem = z.infer<typeof SupplierRoleListItemSchema>;
